export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      activities: "Activités",
      about: "À propos",
      contact: "Contact",
      book: "Réserver",
    },
    hero: {
      eyebrow: "Conciergerie touristique · Agadir",
      title: "Vivez Agadir\nautrement",
      subtitle:
        "Jet ski, désert, soirées marocaines… Nous concevons vos expériences les plus mémorables sur la côte atlantique du Maroc.",
      cta: "Découvrir les activités",
      ctaSecondary: "Nous contacter",
      stat1: "Activités d'exception",
      stat2: "Sur mesure",
      stat3: "Réservation facile",
    },
    intro: {
      eyebrow: "Bienvenue chez AGADIR VIBES",
      title: "Votre conciergerie d'expériences à Agadir",
      text: "De l'adrénaline sur l'océan aux nuits étoilées du désert, AGADIR VIBES sélectionne pour vous les plus belles activités de la région. Réservation simple, prestataires de confiance, souvenirs garantis.",
    },
    activities: {
      eyebrow: "Nos expériences",
      title: "Activités populaires",
      subtitle: "Une sélection d'aventures uniques, sur mer, dans le désert et sous les étoiles.",
      viewAll: "Voir toutes les activités",
      allTitle: "Toutes nos activités",
      allSubtitle: "Explorez l'ensemble de nos expériences à Agadir et ses environs.",
      from: "À partir de",
      popular: "Populaire",
      details: "Détails",
      empty: "Aucune activité dans cette catégorie.",
    },
    why: {
      eyebrow: "Pourquoi nous choisir",
      title: "L'expérience AGADIR VIBES",
      items: [
        { title: "Sélection premium", text: "Des prestataires locaux triés sur le volet pour votre sécurité et votre plaisir." },
        { title: "Sur mesure", text: "Anniversaires, EVJF, demandes en mariage : nous personnalisons chaque instant." },
        { title: "Réservation simple", text: "Réservez en ligne en quelques clics ou contactez-nous directement." },
        { title: "Assistance locale", text: "Une équipe francophone à Agadir, disponible 7j/7." },
      ],
    },
    testimonials: {
      eyebrow: "Ils ont vécu l'expérience",
      title: "Ce que disent nos voyageurs",
    },
    ctaBand: {
      title: "Prêt à vivre l'expérience ?",
      text: "Contactez-nous et composons ensemble votre séjour à Agadir.",
      button: "Réserver maintenant",
    },
    detail: {
      back: "Retour aux activités",
      about: "À propos de l'expérience",
      included: "Ce qui est inclus",
      pricing: "Tarifs",
      duration: "Durée",
      location: "Lieu",
      option: "Formule",
      book: "Réserver",
      goodToKnow: "Bon à savoir",
      other: "D'autres expériences",
      preNote: "Réservation sous réserve d'acceptation et de disponibilité du prestataire.",
    },
    booking: {
      title: "Réservation",
      subtitle: "Confirmée sous réserve d'acceptation et de disponibilité du prestataire.",
      notice: "Votre réservation est soumise à l'acceptation et à la disponibilité du prestataire. Seul l'acompte est débité à cette étape.",
      name: "Nom complet",
      namePh: "Votre nom",
      email: "Email",
      emailPh: "vous@email.com",
      phone: "Téléphone",
      phonePh: "+212 …",
      activity: "Activité",
      option: "Formule",
      date: "Date souhaitée",
      pickDate: "Choisir une date",
      people: "Nombre de personnes",
      adults: "Adultes",
      children: "Enfants (-50%)",
      addons: "Options en supplément",
      message: "Message (optionnel)",
      messagePh: "Une demande particulière ?",
      disclaimer:
        "Je comprends qu'une fois la réservation confirmée par le prestataire, la prestation se déroule directement entre le client et le prestataire. AGADIR VIBES agit uniquement en tant qu'intermédiaire et décline toute responsabilité.",
      submit: "Réserver et payer l'acompte",
      submitting: "Envoi…",
      successTitle: "Réservation envoyée !",
      successText: "Merci ! Nous vérifions la disponibilité auprès du prestataire et revenons vers vous rapidement pour confirmer votre réservation.",
      required: "Veuillez remplir tous les champs obligatoires.",
      mustAccept: "Veuillez accepter les conditions pour continuer.",
      total: "Montant estimé",
      depositLabel: "Acompte à régler en ligne maintenant",
      perPerson: "par personne",
      balanceNote: "Le solde sera réglé directement au prestataire le jour de l'activité.",
      redirecting: "Redirection vers le paiement sécurisé…",
      errorGeneric: "Une erreur est survenue. Merci de réessayer.",
    },
    footer: {
      tagline: "Conciergerie d'activités touristiques à Agadir, Maroc.",
      explore: "Explorer",
      contactTitle: "Contact",
      follow: "Suivez-nous",
      rights: "Tous droits réservés.",
      call: "Appelez-nous",
      whatsapp: "WhatsApp",
    },
    contactPage: {
      title: "Contactez-nous",
      subtitle: "Une question, un projet sur mesure ? Écrivez-nous, nous répondons rapidement.",
    },
  },
  en: {
    nav: {
      home: "Home",
      activities: "Activities",
      about: "About",
      contact: "Contact",
      book: "Book now",
    },
    hero: {
      eyebrow: "Tourist concierge · Agadir",
      title: "Experience Agadir\nlike never before",
      subtitle:
        "Jet ski, desert, Moroccan nights… We craft your most memorable experiences on Morocco's Atlantic coast.",
      cta: "Discover activities",
      ctaSecondary: "Contact us",
      stat1: "Exceptional activities",
      stat2: "Tailor-made",
      stat3: "Easy booking",
    },
    intro: {
      eyebrow: "Welcome to AGADIR VIBES",
      title: "Your experience concierge in Agadir",
      text: "From adrenaline on the ocean to starry desert nights, AGADIR VIBES curates the finest activities in the region for you. Simple booking, trusted partners, guaranteed memories.",
    },
    activities: {
      eyebrow: "Our experiences",
      title: "Popular activities",
      subtitle: "A selection of unique adventures — at sea, in the desert and under the stars.",
      viewAll: "View all activities",
      allTitle: "All our activities",
      allSubtitle: "Explore all of our experiences in and around Agadir.",
      from: "From",
      popular: "Popular",
      details: "Details",
      empty: "No activity in this category.",
    },
    why: {
      eyebrow: "Why choose us",
      title: "The AGADIR VIBES experience",
      items: [
        { title: "Premium selection", text: "Hand-picked local partners for your safety and enjoyment." },
        { title: "Tailor-made", text: "Birthdays, hen parties, proposals: we personalise every moment." },
        { title: "Easy booking", text: "Book online in a few clicks or contact us directly." },
        { title: "Local support", text: "A dedicated team in Agadir, available 7 days a week." },
      ],
    },
    testimonials: {
      eyebrow: "They lived the experience",
      title: "What our travellers say",
    },
    ctaBand: {
      title: "Ready to live the experience?",
      text: "Get in touch and let's craft your Agadir getaway together.",
      button: "Book now",
    },
    detail: {
      back: "Back to activities",
      about: "About the experience",
      included: "What's included",
      pricing: "Pricing",
      duration: "Duration",
      location: "Location",
      option: "Option",
      book: "Book now",
      goodToKnow: "Good to know",
      other: "Other experiences",
      preNote: "Booking subject to the provider's acceptance and availability.",
    },
    booking: {
      title: "Booking",
      subtitle: "Confirmed subject to the provider's acceptance and availability.",
      notice: "Your booking is subject to the provider's acceptance and availability. Only the deposit is charged at this stage.",
      name: "Full name",
      namePh: "Your name",
      email: "Email",
      emailPh: "you@email.com",
      phone: "Phone",
      phonePh: "+212 …",
      activity: "Activity",
      option: "Option",
      date: "Preferred date",
      pickDate: "Pick a date",
      people: "Number of people",
      adults: "Adults",
      children: "Children (-50%)",
      addons: "Optional extras",
      message: "Message (optional)",
      messagePh: "Any special request?",
      disclaimer:
        "I understand that once the booking is confirmed by the provider, the service takes place directly between the client and the provider. AGADIR VIBES acts only as an intermediary and declines any liability.",
      submit: "Book & pay deposit",
      submitting: "Sending…",
      successTitle: "Booking sent!",
      successText: "Thank you! We're checking availability with the provider and will get back to you shortly to confirm your booking.",
      required: "Please fill in all required fields.",
      mustAccept: "Please accept the terms to continue.",
      total: "Estimated amount",
      depositLabel: "Deposit to pay online now",
      perPerson: "per person",
      balanceNote: "The balance is paid directly to the provider on the day of the activity.",
      redirecting: "Redirecting to secure payment…",
      errorGeneric: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "Tourist activity concierge in Agadir, Morocco.",
      explore: "Explore",
      contactTitle: "Contact",
      follow: "Follow us",
      rights: "All rights reserved.",
      call: "Call us",
      whatsapp: "WhatsApp",
    },
    contactPage: {
      title: "Contact us",
      subtitle: "A question, a tailor-made project? Write to us, we reply quickly.",
    },
  },
};
